import React from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';
import './DnevnepromjeneDonat.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';



import Fab from '@mui/material/Fab';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';


import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';


import Loader3 from './Loader3';
import { DataGrid,
    useGridApiRef,
    DEFAULT_GRID_AUTOSIZE_OPTIONS,} from '@mui/x-data-grid';
import axios from 'axios';
import { APICall } from './services/api.service';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "./redux/actions"
import AutoModal from './AutoModal';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {statusObradeOptions, trebaLiSklonitiOptions} from './variables/variables.js';

import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import Swal from 'sweetalert2';
import { Alert } from '@mui/material';

import * as useLocalStorage from './services/useLocalStorage'
import BijeleStranice from './BijeleStranice.js';
import ZuteStranice from './ZuteStranice.js';

import ExportCSV from './ExportCSV';

//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";


const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
    mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: '#520074',
          // Headers, and top & bottom fixed rows
          containerBackground: 'primary',
        },
      },

});


function BadData() {




    const [filteredTableData, setFilteredTableData] = useState([],[])
   
    
    const [filters, setFilters] = useState([false, false, false, false, false, false, false, false, false])


    const [selectedItemsBadData, setSelectedItemsBadData] = useState([]);


    
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const [curr_time, setCurrTime] = useState('');


    const token = localStorage.getItem("token");


    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");

    const adminDailyData = localStorage.getItem("adminDailyData");
    const [seeDataAdmin, setSeeDataAdmin] = useState(false);





    const [tkList, setTkList] = useState([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);



    const [bureInfo, setBureInfo] = useState('');

    const [telefon, setTelefon] = useState('');
    const [OIB, setOIB] = useState('');
    const [obrnuto, setObrnuto] = useState('');
    const [telefon2, setTelefon2] = useState('');
    const [OIB2, setOIB2] = useState('');
    const [obrnuto2, setObrnuto2] = useState('');



    const [naziv1, setNaziv1] = useState('');
    const [naziv2, setNaziv2] = useState('');
    const [naziv12, setNaziv12] = useState('');
    const [naziv22, setNaziv22] = useState('');
    const [mjesto, setMjesto] = useState('');
    const [mjesto2, setMjesto2] = useState('');
    const [ulica, setUlica] = useState('');
    const [ulica2, setUlica2] = useState('');
    const [kbr, setKbr] = useState('');
    const [kbr2, setKbr2] = useState('');
    const [ptt, setPtt] = useState('');
    const [ptt2, setPtt2] = useState('');
    const [tip, setTip] = useState('');
    const [tip2, setTip2] = useState('');
    const [tip3, setTip3] = useState('');
    const [tip12, setTip12] = useState('');
    const [tip22, setTip22] = useState('');
    const [tip32, setTip32] = useState('');
    const [datum_mobile, setDatumMobile] = useState('');
    const [datum_mobile2, setDatumMobile2] = useState('');
    const [datumVal, setDatumVal] = useState('');
    const [datumVal2, setDatumVal2] = useState('');
    const [operator, setOperator] = useState('');
    const [akcija, setAkcija] = useState('');
    const [isObjava, setIsObjava] = useState(false);

    const [name, setName] = useState('');
    const [name2, setName2] = useState('');
    const [surname, setSurname] = useState('');
    const [surname2, setSurname2] = useState('');

 


    const [rucnoNaziv1, setRucnoNaziv1] = useState('');
    const [rucnoNaziv2, setRucnoNaziv2] = useState('');
    const [rucnoMjesto, setRucnoMjesto] = useState('');
    const [rucnoUlica, setRucnoUlica] = useState('');
    const [rucnoKBR, setRucnoKBR] = useState('');
    const [rucnoKBRDodatak, setRucnoKBRDodatak] = useState('');
    const [selectedRucnoTip, setSelectedRucnoTip] = useState(3);

    const [rucneKorekcije, setRucneKorekcije] = useState(true);

    const [tkOperatorRow, setTkOperatorRow] = useState('');
    const [tkOperatorRowID, setTkOperatorRowID] = useState('');
    const [akcijaRow, setAkcijaRow] = useState('');
    const [changingTKC, setChangingTKC] = useState(false);

    const [activeTKCRow, setActiveTKCRow] = useState('');
    

    const [chosenTKCRow, setChosenTKCRow] = useState('');


    const [flagChangeName, setFlagChangeName] = useState(false);


    const [listOfPozivni, setListOfPozivni] = useState([]);
    


    const korisnik = useSelector((state) =>state.korisnik ? state.korisnik.value : "" )



    const tkc = JSON.parse(localStorage.getItem("tkc"));

    const [poziv, setPoziv] = useState(JSON.parse(useLocalStorage.getItem("tkc")));

    const tkc2 = useSelector((state) =>state.TKC ? state.TKC.value : {tkc: "", pozivni: ""} )
    //const tkc2 = useSelector((state) =>state.tkc)

   

    const [pojavljivanjeIsOpen, setPojavljivanjeIsOpen] = useState(false)
    const [selectedCell, setSelectedCell] = useState()



    const togglingValue = useSelector((state) => state.togglingVariable?state.togglingVariable.value: 0);
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)

    const [changeOwner, setChangeOwner] = useState(false);

    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };
   



useEffect(() => {
        

        let tmp = new Date();

        if(adminDailyData== 1) setSeeDataAdmin(true);

        tmp.setMinutes(tmp.getMinutes() - 25);


        let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();

        setCurrTime(timeNow);

        getOperatori();
        getErrors();

        getCallingCode();


}, []);

useEffect(()=>{
        document.title="Neispravni podaci"
},[])


    const [showBadData, setShowBadData] = useState(false);
    const [badData, setBadData] = useState([],[]);

    //const [operatori, setOperatori] = useState([{naziv:'aaa', id:'44'},{naziv:'abc', id:'77'},{naziv:'aaddda', id:'3'}]);
    const [operatori, setOperatori] = useState([]);



    const [currOper, setCurrOper] = useState({});


    const [errors, setErrors] = useState([]);

    const [currError, setCurrError] = useState({});

    //const [callingCodes, setCallingCodes] = useState([{naziv:'1', id:'1'},{naziv:'20', id:'2'},{naziv:'21', id:'3'}]);
    const [callingCodes, setCallingCodes] = useState([]);

    const [currCallingCode, setCurrCallingCode] = useState({});

    const [checked, setChecked] = useState(false);

    const [doneCheck, setDoneCheck] = useState(0);

    const [chosenDate, setChosenDate] = useState('');

    

async function getOperatori () {


        dispatch(actions.isLoading());


        
        APICall(

            '/GetOperatori',
            {

                platform: '0',
                version:'1.0',

            },
            {
                token
            }).then(


                (response) => {
                
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());
                
                                if(response.data.list && response.data.list.length!=0){
                                        var dataTmp = response.data;

                                        console.log("/*********************************************************************/");
                                        console.log(dataTmp.list[0]);
                                        console.log("/*********************************************************************/");


                                        setOperatori(dataTmp.list)



                    
                                        
                                    }else{



                                            setOperatori([])


                                    }
            
                        
                
                },

                (error) => {

                    dispatch(actions.isNotLoading());

                
                    setOperatori([]);


                
                            if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                            } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });

            
            
}  

async function getErrors () {


    dispatch(actions.isLoading());


    
    APICall(

        '/GetErrors',
        {

            platform: '0',
            version:'1.0',

        },
        {
            token
        }).then(


            (response) => {
            
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log("/*********************************************************************/");
                                    console.log(dataTmp.list[0]);
                                    console.log("/*********************************************************************/");


                                    setErrors(dataTmp.list)



                
                                    
                                }else{



                                        setErrors([])


                                }
        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setErrors([]);


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

        
        
}  

async function getCallingCode () {


    dispatch(actions.isLoading());


    
    APICall(

        '/GetCallingCode',
        {

            platform: '0',
            version:'1.0',

        },
        {
            token
        }).then(


            (response) => {
            
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log("/*********************************************************************/");
                                    console.log(dataTmp.list[0]);
                                    console.log("/*********************************************************************/");


                                    setCallingCodes(dataTmp.list)



                
                                    
                                }else{



                                    setCallingCodes([])


                                }
        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setCallingCodes([]);


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

        
        
}  

async function getBadData (oper, err, cc, dd, datum) {


    dispatch(actions.isLoading());

    let chosenOP = '';

    let chosenErr = '';

    let chosenCC = '';

    let chosenDD = '';

    if(oper && oper.id && oper.id!=''){

        console.log("Odabran operator");

        console.log(oper)

        chosenOP = oper.id;

    } else {


        chosenOP = '';
    }

    if(err && err.id && err.id!=''){

        console.log("Odabrana mreza");

        console.log(err)

        chosenErr = err.id;

    } else {


        chosenErr = '';
    }
    

    if(cc && cc.id && cc.naziv!=''){

        console.log("Odabrana greska");

        console.log(cc)

        chosenCC = cc.naziv;

    } else {


        chosenCC = '';
    }

    if(datum && datum!=''){

        console.log("Datum postoji!");

        console.log(datum);

        chosenDD = datum;
    }

    APICall(
    
        '/GetBadData',
        
        {

                platform: '0',
                version:'1.0',
                //oper: tkList.map(item=>item.toString()),
                oper:chosenOP,
                err: chosenErr,
                cc: chosenCC,
                done: dd,
                datum: chosenDD

            },
        {
            token
        }).then(


            (response) => {
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log("/*********************************************************************/");
                                    console.log(dataTmp.list[0]);
                                    console.log("/*********************************************************************/");

                                    
                                    const unique = [...new Set(dataTmp.list.map(item => item.kod))];



                                    let tmpErr = errors.map((el)=>{
                                                
                                      
                                                let disabled = unique.find((element) => element == el.id);
                                               
                                          
                                                return {naziv: el.naziv, id: el.id, 
                                                    disabled: disabled?false:true} 

                                    });

                                    
                                    setErrors(tmpErr);

                                    




                                    let i = 0;

                                    let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                      
                                        let widthC = 100;
                                        switch(column) {
                                            case "Opis":
                                                widthC = 200;
                                                break;
                                            case "Naziv1":
                                                widthC = 200;
                                                break;
                                            case "Naziv1":
                                                widthC = 200;
                                                break;
                                            case "Mjesto":
                                                widthC = 150;
                                                break;
                                            case "KucniBr":
                                                widthC = 50;
                                                break;
                                            case "KucnoSlovo":
                                                widthC = 50;
                                                break;
                                            case "Operator":
                                                widthC = 100;
                                                break;
                                            case "Ulica":
                                                widthC = 150;
                                                break;
                                            default:
                                                // code block
                                            } 
                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                "width": widthC

                                            
                                            }
                                        )
                                    })

                                    const updatedColumns = columns.map((col) => {
                                        
                                        if (col.field === 'Datum') {

                            
                                            return {
                                            ...col,
                                            valueFormatter: ({ value }) => {
                                                if (value) {
                                                const date = new Date(value);
                                                console.log(date)
                                                console.log(date.toLocaleDateString());
                                                return date.toLocaleDateString(); // Format as MM/DD/YYYY (or customize)
                                                }
                                                return value;
                                            },
                                            sortComparator: (v1, v2) => {
                                                const date1 = new Date(v1);
                                                const date2 = new Date(v2);
                                                return date1 - date2; // Compare dates
                                            },
                                            };
                                        }
                                        return col;
                                    });

                                    columns = updatedColumns;

                                    
                                    let rows =dataTmp.list.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    setBadData({
                                            columns,
                                            rows
                                    })

                                    setShowBadData(true);


                                    setFilteredTableData([],[]);
                        
                                    
                                    setSelectedCell(null)

                                    setSelectedItemsBadData([]);

                                    console.log("Selected items: ");
                                    console.log(selectedItemsBadData);

    
                                    setTelefon('');
                                    setTelefon2('');
                                    setOperator('');
                                
    
                                    setNaziv1('')
                                    
                                    setNaziv12('');
                                    
                                    setOIB('');
                                    setOIB2('');
    
    
                                    
    
    
                                    setIsObjava(false);
    
                                    
    
                                    setMjesto('')
                                    setMjesto2('')
    
                                    setPtt('');
                                    setPtt2('');
    
                                    
                                    setUlica('');
                                    setUlica2('');
    
                                    
    
    
                                    
                                    setTip('');
                                    setTip12('');
                                    setTip2('');
                                    setTip22('');
                                    setTip3('');
                                    setTip32('');
    
    
    
                                    
    
    
                                    setDatumVal('');
    
    
                                    setName('');
                                    setSurname('');
                                    setName2('');
                                    setSurname2('')
    
    
                                    setObrnuto('  ');
                                    setObrnuto2('  ');

                                    setTkOperatorRow('');
                                    setAkcijaRow('');

                                    setActiveTKCRow('');
                                    setTkOperatorRowID('');

                                    setRucnoKBR('');
                                    setRucnoKBRDodatak('');
                                    setRucnoMjesto('');
                                    setRucnoUlica('');
                                    setRucnoNaziv1('');
                                    setRucnoNaziv2('');
                                    setSelectedRucnoTip(3);
                                    //setRucneKorekcije(false);

                                    setBureInfo('');
                                    
                                    setFilters([false, false, false, false, false, false, false, false, false]);



                    
                                        
                                    }else{

        

                                    // toast.info(response.data.message,
                                    //     toastError);
                                
                

                                    setBadData([],[])

                                

                                    }
            
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setBadData([],[]);


            
                        if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                        } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                        }
                    
                    
            
            
            });

            
            
}      






const obrisiOdabrano=() => {




    Swal.fire({
        title: `Jeste li sigurni da želite obrisati sve odabrane podatke?`,
        text: "Ova radnja se ne može poništiti",
        icon: "warning",
        iconSize: '5',

        showCancelButton: true,
        confirmButtonColor: "#e31b2e",
        cancelButtonColor: "#29648a",
        showCancelButton: true,
        confirmButtonText: "Da, obriši!",
        cancelButtonText: "Odustani",
        reverseButtons: true
        }).then((result) => {
        if (result.isConfirmed) {

                deleteBadData();

        }
        });
    
};
    
async function deleteDailyData () {


    

    console.log("Brišem za operatora: ");

    console.log(currOper);

    if(currOper.id == 33){

        toast.error("Nije moguće brisati listu za Donat", toastError);

    } else {


                        Swal.fire({
                            title: `Jeste li sigurni da želite obrisati današnje dolazne podatke za odabranog operatera?`,
                            text: "Ova radnja se ne može poništiti",
                            icon: "warning",
                            iconSize: '5',
                    
                            confirmButtonText: "Da, obriši!",
                            confirmButtonColor: "#e31b2e",
                            cancelButtonColor: "#29648a",
                            //showDenyButton: true,
                            showCancelButton: true,
                            
                            //denyButtonColor:'blue',
                            //denyButtonText: "Samo odabrani redak",
                            
                            cancelButtonText: "Odustani",
                            showCancelButton: true,
                            reverseButtons: false
                            }).then((result) => {
                            if (result.isConfirmed) {
                                
                                dispatch(actions.isLoading());

                                console.log("Ref: ");
                    
                                console.log(ref);
                    
                                let tmpDate = new Date();
                    
                                console.log(tmpDate);
                    
                                let tmpDate2 = dayjs(new Date()).format('YYYY-MM-DD');
                    
                                console.log("Formatted date");
                                console.log(tmpDate2);
                    
                    
                                
                                APICall(
                                    '/makniListuOperator',
                                    
                                    {
                    
                                        platform: '0',
                                        version:'1.0',
                                        referent: ref,
                                        tkID: currOper.id,
                                        date: tmpDate2
                                        
                    
                                    },
                                    {
                                        token
                                    }).then(
                    
                    
                                        (response) => {
                                        
                                            dispatch(actions.isNotLoading());
                    
                                            setSelectedItemsBadData([]);
                    
                                            if(response==undefined) dispatch(actions.isNotLoading());
                                        
                                            if(response.status==200){
                                                    
                                                toast.success(response.data.message, toastSuccess);
                    
                                                setSelectedItemsBadData([]);
                    
                                                getBadData(currOper, currError, currCallingCode, doneCheck, chosenDate);
                                            
                    
                                            } else {
                    
                                                if(response.status == 401){
                    
                                                        console.log("Istekla sesija");
                                
                                                        toast.error(response.data.message, toastError);
                                                        
                                                        dispatch(actions.logOut());
                                                        navigate('/');
                    
                                                } else {
                                                        toast.error(response.data.message,
                                                            toastError);
                                                                            
                    
                                                }
                            
                                        
                                            }        
                                        
                                        },
                    
                                        (error) => {
                    
                                            dispatch(actions.isNotLoading());
                    
                                        
                                        
                    
                    
                                        
                                                    if(!error.response){
                    
                                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                            toastError);
                                                    
                    
                    
                                                    } else {
                    
                    
                                                        if(!error.response.status){
                    
                                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                            toastError);
                    
                                                        }else{
                    
                                                            if (error.response.status == 401) {
                                        
                                                    
                                                                toast.error(error.response.data.message,
                                                                        toastError);
                                                                
                                                                        setTimeout(() => {
                                                                            dispatch(actions.logOut());
                                                                            navigate('/');
                                                                        }, 5000);   
                    
                                                            
                                                        
                                                            } else {
                                                        
                                                        
                                                                        toast.error(error.response.data.message,
                                                                            toastError);
                                                                                                    
                                                                
                                                            }
                                                        }
                                                    }
                                                
                                            
                                        
                                        
                                        });
                                        
        
                                }
                            });



            
    }
            
            
}      


async function deleteBadData () {


    dispatch(actions.isLoading());

    console.log(selectedItemsBadData.length);

    
    APICall(
        '/deleteBadData',
        
        {

             platform: '0',
             version:'1.0',
             selected: selectedItemsBadData,

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                setSelectedItemsBadData([]);

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){
                        
                    toast.success(response.data.message, toastSuccess);

                    setSelectedItemsBadData([]);

                    getBadData(currOper, currError, currCallingCode, doneCheck, chosenDate);
                

                } else {

                    if(response.status == 401){

                            console.log("Istekla sesija");
    
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');

                    } else {
                            toast.error(response.data.message,
                                toastError);
                                                

                    }
  
               
                }        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
            


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}      


async function doneBadData () {


    dispatch(actions.isLoading());

    console.log(selectedItemsBadData.length);

    
    APICall(
        '/doneBadData',
        
        {

             platform: '0',
             version:'1.0',
             selected: selectedItemsBadData,

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                setSelectedItemsBadData([]);

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){
                        
                    toast.success(response.data.message, toastSuccess);

                    setSelectedItemsBadData([]);

                    getBadData(currOper, currError, currCallingCode, doneCheck, chosenDate);
                

                } else {

                    if(response.status == 401){

                            console.log("Istekla sesija");
    
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');

                    } else {
                            toast.error(response.data.message,
                                toastError);
                                                

                    }
  
               
                }        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
            


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}      


function rucnaKorekcija(){



                let unmounted = false;
                let source = axios.CancelToken.source();
    
                console.log("Ručna korekcija!!!");
                console.log(telefon);
                console.log(selectedRucnoTip);
                console.log(selectedUlica);
                console.log(selectedMjesto);

                let tmpTip = tip;

                console.log(tmpTip)

                if(selectedRucnoTip == 0){

                            tmpTip = "Privatni"
                }else if(selectedRucnoTip == 1 || selectedRucnoTip == 2){

                            tmpTip = "Poslovni"

                }

                let tmptel= telefon;
                let tmpNaziv1 = rucnoNaziv1?rucnoNaziv1:'';
                let tmpNaziv2 =  rucnoNaziv2?rucnoNaziv2:'';

            

                let tmpmj_id = selectedMjesto.ID;
                let tmpulica_id = selectedUlica.ID;
                let tmpkbr = rucnoKBR?rucnoKBR:'';
                let tmpkbr_plus = rucnoKBRDodatak?rucnoKBRDodatak:'';





    
                APICall(
                    '/RucnaKorekcija',
                    {
    
                        platform: '0',
                        version:'1.0',
                        tel: telefon,
                        naziv1: tmpNaziv1,
                        naziv2: tmpNaziv2,
                        mj_id: tmpmj_id,
                        ulica_id: tmpulica_id,
                        kbr: tmpkbr,
                        kbr_plus: tmpkbr_plus,
                        tip: tmpTip
    
                    },
                    {
                        token
                    }).then(
    
    
                        (response) => {
    
                                if (!unmounted) {
                        
    
    
                                            var dataTmp = response.data;
                                                //console.log()(response)
                                            toast.info(dataTmp.message,
                                                            toastInfo);
                                                    

                                }
                        
                        },
    
                        (error) => {
    
                            if (!unmounted) {
                        
                        
    
    
                        
                                    if(!error.response){
    
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
    
    
                                    } else {
    
    
                                        if(!error.response.status){
    
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
    
                                        }else{
    
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
    
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            }
                        
                        
                        });
    

}



const customLocaleText = {
    // Filter panel
    filterPanelAddFilter: 'Dodajte filter',
    filterPanelDeleteIconLabel: 'Ukloniti',
    filterPanelOperators: 'Operatori',
    filterPanelOperatorAnd: 'I',
    filterPanelOperatorOr: 'Ili',
    filterPanelColumns: 'Stupci',
    filterPanelInputLabel: 'Spremi',
  
    // Toolbar
    toolbarColumns: 'Stupci',
    toolbarFilters: 'Filteri',
    toolbarDensity: 'Gustoća',
    toolbarExport: 'Eksport',
    
    // Column menu
    columnMenuSortAsc: 'Uzlazno sortiranje',
    columnMenuSortDesc: 'Silazno sortiranje',
    columnMenuFilter: 'Filtrirati',
    columnMenuHideColumn: 'Sakrij stupac',
    columnMenuUnsort: 'Ukloni sortiranje',

    toolbarQuickFilterPlaceholder: 'Traži...',
    toolbarQuickFilterLabel: 'Traži',
    toolbarQuickFilterDeleteIconLabel: 'Očisti',
      // Filter operators text
  filterOperatorContains: 'sadrži',
  filterOperatorDoesNotContain: 'ne sadrži',
  filterOperatorEquals: 'jednako',
  filterOperatorDoesNotEqual: 'nije jednako',
  filterOperatorStartsWith: 'počinje s',
  filterOperatorEndsWith: 'završava s',
  filterOperatorIs: 'je',
  filterOperatorNot: 'nije',
  filterOperatorAfter: 'je iza',
  filterOperatorOnOrAfter: 'je na ili iza',
  filterOperatorBefore: 'je prije',
  filterOperatorOnOrBefore: 'je na ili prije',
  filterOperatorIsEmpty: 'je prazno',
  filterOperatorIsNotEmpty: 'nije prazno',
  filterOperatorIsAnyOf: 'je među',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

    // Column menu text
    columnMenuLabel: 'Izbornik',
    columnMenuShowColumns: 'Pokaži stupce',
    columnMenuManageColumns: 'Uredi stupce',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Sakrij stupac',
    columnMenuUnsort: 'Ukloni sortiranje',
    columnMenuSortAsc: 'Sortiraj uzlazno',
    columnMenuSortDesc: 'Sortiraj silazno',

      // Columns management text
  columnsManagementSearchTitle: 'Traži',
  columnsManagementNoColumns: 'Nema stupaca',
  columnsManagementShowHideAllText: 'Prikaži/sakrij sve',
  columnsManagementReset: 'Resetiraj',

      // Checkbox selection text
  checkboxSelectionHeaderName: 'Odabir redaka',
  checkboxSelectionSelectAllRows: 'Odaberi sve retke',
  checkboxSelectionUnselectAllRows: 'Ukloni odabir',
  checkboxSelectionSelectRow: 'Odaberi redak',
  checkboxSelectionUnselectRow: 'Ukloni odabir retka',
  
    // Rows
    footerRowSelected: (count) => `${count} redaka odabrano`,
    noRowsLabel: 'Nije odabran nijedan redak',
  };

  const myEventHandler = (e) => {
    console.log("Opened contexxxxxxxt");
    console.log("yaaay");
}



const [tkcFirma, setTkcFirma] = useState('');
const [listUlice, setListUlice] = useState([]);
const [selectedUlica, setSelectedUlica] = useState();


const [listMjesta, setListMjesta] = useState([]);
const [selectedMjesto, setSelectedMjesto] = useState();

async function searchForUlica(val){

    if(val.length>4){
       
        APICall(
            '/getUlicaSuggestion',
            {
    
                platform: '0',
                version:'1.0',

                val: val
    
            },
            {
                token
            }).then(
    
    
                (response) => {
                    console.log(response)
    
    
                    if (response.status==200) {
                        
                           setListUlice(response.data.strukture)
                     
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    } else{
        setListUlice([])
        

    }
}

async function searchForMjesto(val){

    if(val.length>3){
       
        APICall(
            '/getMjestoSuggestion',
            {
    
                platform: '0',
                version:'1.0',

                val: val
    
            },
            {
                token
            }).then(
    
    
                (response) => {
                    console.log(response)
    
    
                    if (response.status==200) {
                        
                            setListMjesta(response.data.strukture)
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    } else{
        setListMjesta([])
    }
}


async function getMjestoFromUlica(val){


       
        APICall(
            '/getMjesto',
            {
    
                platform: '0',
                version:'1.0',

                id: val
    
            },
            {
                
                token

            }).then(
    
    
                (response) => {
                    
                    console.log(response)
    
    
                    if (response.status==200) {
                        
                            console.log(response.data.mjesto);


                            setSelectedMjesto(response.data.mjesto[0])
                            setRucnoMjesto(response.data.mjesto[0].NAZIV);
                            setTkcFirma(response.data.mjesto[0].ID_TKC)

                            

                            
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    
}


const VISIBLE_FIELDS = ['Naziv', 'Telefon', 'Adresa'];

const apiRef = useGridApiRef();

return (
    <ThemeProvider theme={theme}>



        <div className="DPDonat-main-container">
        <div className={`DPDonat-header ${isMenuOpen ? "is-extended": ""}`}            
                onMouseEnter={()=> dispatch(actions.openMenu())}
                onMouseLeave={()=> dispatch(actions.closeMenu())}
            >

                <div className="DPDonat-header-changes-title">

                    <Typography className="DPDonat-header-changes-title-text" variant="h5">
                        Val - Neispravni podaci svih operatera
                    </Typography>

                </div>

            </div>
            <div className="DPDonat-body">
                <div className="BadData-data-display">

                <Grid container spacing={2}>



                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary" disabled={showBadData}
                                        onClick={() => {
                                            
                                            getBadData(currOper, currError, currCallingCode, doneCheck, chosenDate);
                                            setShowBadData(true);
                                        }}
                                 
                                        >
                                        Prikaži podatke
                                    </Button>
                        </Grid>
                       
 
                        
                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" disabled={!showBadData}
                                        onClick={() => {
                                           
                                               
                                            obrisiOdabrano();
                                        }}
                                 
                                        >
                                        Obriši odabrane podatke
                                    </Button>
                        </Grid>

                        {seeDataAdmin && <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" disabled={!currOper || currOper=='' || !currOper.id || currOper.id==''}
                                        onClick={() => {
                                           
                                               
                                                deleteDailyData();
                                        }}
                                 
                                        >
                                        Obriši dnevnu listu operatera
                                    </Button>
                        </Grid> }
                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="success" disabled={!showBadData}
                                        onClick={() => {
                                           
                                               
                                                doneBadData();
                                        }}
                                 
                                        >
                                        Označi riješeno
                                    </Button>
                        </Grid>      

                        {/*<Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary"
                                        onClick={() => {
                                           

                                            //prebaciIspravljeno();


                                        }}
                                 
                                        >
                                        U listu
                                    </Button>
                        </Grid>*/}
                        


                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" disabled={!showBadData}
                                        onClick={() => {

                                    
                                            setShowBadData(false);
                                            setFilteredTableData([],[]);
                                
                                            
                                            setSelectedCell(null)
        
            
                                            setTelefon('');
                                            setTelefon2('');
                                            setOperator('');
                                       
            
                                            setNaziv1('')
                                           
                                            setNaziv12('');
                                            
                                            setOIB('');
                                            setOIB2('');
            
            
            
                                            setMjesto('')
                                            setMjesto2('')
            
                                            setPtt('');
                                            setPtt2('');
            
                                            
                                            setUlica('');
                                            setUlica2('');
            
                                            
            
            
                                            
                                            setTip('');
                                            setTip12('');
                                            setTip2('');
                                            setTip22('');
                                            setTip3('');
                                            setTip32('');
            
            
            
            
            
                                            setDatumVal('');
            
            
                                            setName('');
                                            setSurname('');
                                            setName2('');
                                            setSurname2('')
            
            
                                            setObrnuto('  ');
                                            setObrnuto2('  ');
        
                                            setTkOperatorRow('');
                                            setAkcijaRow('');
        
                                            setActiveTKCRow('');
                                            setTkOperatorRowID('');
        
                                            setRucnoKBR('');
                                            setRucnoKBRDodatak('');
                                            setRucnoMjesto('');
                                            setRucnoUlica('');
                                            setRucnoNaziv1('');
                                            setRucnoNaziv2('');
                                            setSelectedRucnoTip(3);
                                            //setRucneKorekcije(false);

                                            setBureInfo('');
                                            

                                        }}
                                 
                                        >
                                        Kraj
                                    </Button>
                        </Grid>


                        {showBadData && selectedItemsBadData && <Grid item xs={2}>
                            <ExportCSV data={selectedItemsBadData} 
                            oper={currOper} chosenDate={chosenDate} err={currError} />
                        </Grid>}

                    

                        </Grid>

                        <Grid container spacing={2} sx={{marginTop:'20px', marginBottom: '20px'}}>

                        <Grid item xs={2}>
                 
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Operator</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={currOper.naziv}
                                label="Operator"

                                
                                onChange={(event) => {
                                    
                                    

                                    console.log(event.target.value);



                                    if(event.target.value == ''){

                                           

                                            let networkCallingCode = {naziv:'',id:''};

                                            setCurrOper(networkCallingCode);

                                           

                                            getBadData(networkCallingCode, currError, currCallingCode, doneCheck, chosenDate);



                                    } else {


                                            let chosenOP = event.target.value;
                                            

                                            let networkCallingCode = operatori.find((it) => it.id === chosenOP);
                    
                                         
                    
                    
                                            setCurrOper(networkCallingCode);
                                            

                                            getBadData(networkCallingCode, currError, currCallingCode, doneCheck, chosenDate);


                                    }


                                    


                                }}
                                >
                                {operatori && operatori.map((op,index)=> {
                                    return (
                                    <MenuItem value={op.id} name={op.naziv}>{op.naziv}</MenuItem>
                                    

                                    )
                                })}
                                <MenuItem value={''} name={''} >Svi</MenuItem>

                                </Select>

                                </FormControl>
                       
          
                        </Grid>


 

                        <Grid item xs={4}>
                 
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Greška</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={currError.naziv}
                                label="Greška"

                                
                                onChange={(event) => {
                                    
                                    
                                    console.log(event.target.value);



                                    if(event.target.value == ''){


                                            let networkCallingCode = {naziv:'',id:''};

                                            setCurrError(networkCallingCode);


                                            getBadData(currOper, networkCallingCode, currCallingCode, doneCheck, chosenDate);



                                    } else {


                                            let chosenOP = event.target.value;
                                            

                                            let networkCallingCode = errors.find((it) => it.id === chosenOP);
                    
                    
                    
                                            setCurrError(networkCallingCode);
                                            

                                            getBadData(currOper, networkCallingCode, currCallingCode, doneCheck, chosenDate);


                                    }


                                    


                                }}
                                >
                                {errors && errors.map((op,index)=> {
                                    return (
                                        <MenuItem value={op.id} name={op.naziv} disabled={op.disabled}>{op.naziv}</MenuItem>

                                    )
                                })}
                                <MenuItem value={''} name={''} >Sve</MenuItem>
                             

                                </Select>

                                </FormControl>
                       
          
                        </Grid>

                        <Grid item xs={2}>
                 
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Mreža</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={currCallingCode.naziv}
                                label="Greška"

                                
                                onChange={(event) => {
                                    
                                    
                                    console.log(event.target.value);



                                    if(event.target.value == ''){

                                    

                                            let networkCallingCode = {naziv:'',id:''};

                                            setCurrCallingCode(networkCallingCode);

                                            

                                            getBadData(currOper, currError, networkCallingCode, doneCheck, chosenDate);



                                    } else {


                                            let chosenOP = event.target.value;
                                            

                                            let networkCallingCode = callingCodes.find((it) => it.id === chosenOP);
                    
                    
                                            setCurrCallingCode(networkCallingCode);
                                            

                                            getBadData(currOper, currError, networkCallingCode, doneCheck, chosenDate);


                                    }


                                    


                                }}
                                >
                                {callingCodes && callingCodes.map((op,index)=> {
                                    return (
                                    <MenuItem value={op.id} name={op.naziv}>{op.naziv}</MenuItem>
                                    

                                    )
                                })}
                                <MenuItem value={''} name={''} >Sve</MenuItem>

                                </Select>

                                </FormControl>
                       
          
                        </Grid>

                        <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
           
        
                                <DatePicker
                                    label="Datum pretrage"
                                    disableFuture 
                                    slotProps={{ field: { clearable: true } }}
                                    minDate={dayjs('2025-02-04')}
                                    format={'DD.MM.YYYY'}
                                    //value={chosenDate}
                                    inputFormat="dd/MM/yyyy"
                                    onChange={(newValue) => {
                                        console.log("Chosen date:");
                                        console.log(newValue);

                                        let chosen = '';
                                        
                                        if(newValue && newValue.toDate()){

                                                console.log(newValue.toDate());
                                                console.log(newValue.toDate().getMonth()+1);
                                                console.log(newValue.toDate().getFullYear());
                                                console.log(newValue.toDate().getDate());

                                                //let month = newValue.toDate().getMonth()+1;
                                                let month = ("0" + (newValue.toDate().getMonth() + 1)).slice(-2)
                                                let days = ("0" + newValue.toDate().getDate()).slice(-2);
                                                chosen = days + '.' + month + '.' + newValue.toDate().getFullYear();

                                        }


                                        setChosenDate(chosen);
                                    
                                        getBadData(currOper, currError, currCallingCode, doneCheck, chosen);
                                        
                                    }}
                                />
                            </LocalizationProvider>    
                        </Grid>

                        <Grid item xs={2}>
                        <FormControlLabel required control={<Checkbox
                            
                            inputProps={{ 'aria-label': 'controlled' }}
                            onChange={(event) => {

                                    let tmp = 0;

                                    console.log("DoneCheck");
                                    console.log(doneCheck);

                                    if(doneCheck == 0){
                                         tmp = 1;
                                         setDoneCheck(1);
                                    } else {

                                        tmp = 0;
                                        setDoneCheck(0);
                                    }

                                    console.log(tmp);

                                    

                                    getBadData(currOper, currError, currCallingCode, tmp, chosenDate);
                            }}
                            />} label="Prikaži riješene" />
                       
          
                        </Grid>   
                    </Grid>




                    <div className="BadData-data-display-table" style={{backgroundColor: togglingValue==1 ? "#eeeeee7a" : "white", display:showBadData? "flex":"none" }}>

   
                        {showBadData && badData.rows && <DataGrid

                            apiRef={apiRef}
                            rowHeight={25}
                            columnHeaderHeight={30}
                            autosizeOptions={{
                                columns: ['Naziv1'],
                                includeOutliers: true,
                                includeHeaders: true,
                                
                                
                              }}
                              
                     
                            
                            disableRowSelectionOnClick
                            checkboxSelection 
                            sx={{
                                '& .MuiDataGrid-footerContainer': {
                                    height: '20px',
                                    minHeight: '20px',
                                },
                                '& .MuiDataGrid-main': {
                                    borderTopLeftRadius:"10px", borderTopRightRadius:"10px"
                                },
                                '& .MuiDataGrid-scrollbar--vertical': {
                                    width:"9px"
                                 },
                                 
                                 '& .MuiDataGrid-scrollbar--horizontal': {
                                    height:"9px"
                                 },
                                 '& .MuiDataGrid-columnHeaders': {
                                    backgroundColor: '#99ABCD',
                                    color:'white'
                                 }
                                 
                              }}
                            columnBufferPx={10}
                            rows={badData.rows.filter((row=>tkc2.tkc=="" ? row.TKC!==tkc2.tkc : row.TKC==tkc2.tkc))}
                            columns={badData.columns}
                            initialState={{
                                pagination: {
                                  paginationModel: { page: 0, pageSize: 100 },
                                }, 
                              }} 


                            disableSelectionOnClick = {true}

                            onRowSelectionModelChange={(newRowSelectionModel) => {
                                let items=[]
                                for(var i=0; i<newRowSelectionModel.length; i++) {
                                    items.push(badData.rows.filter(row=>row.id===newRowSelectionModel[i]))
                                   
                                }
                                
                             
                                console.log("Selecetedddeeddeeddde");
                                console.log(items.length);

                                console.log(items);
                                

                                setSelectedItemsBadData(items);
                                //console.log()("korisnik", korisnik)


                                

                            }}
                            onCellClick={(newRowSelectionModel)=>{
                                   

                                    setSelectedCell(newRowSelectionModel.row)

    
                                    setTelefon(newRowSelectionModel.row.Tel);
                                   

                                    //setOperator(newRowSelectionModel.row.operator);

                                    
    
                                    setNaziv1(newRowSelectionModel.row.Naziv1)
                                    

                                    setName(newRowSelectionModel.row.Naziv1);
                                    
                                    setSurname(newRowSelectionModel.row.Naziv2);
                                    
                                    setOIB(newRowSelectionModel.row.OIB);
                                

                                    //setIsObjava(newRowSelectionModel.row.Tajni);
    
                                    setMjesto(newRowSelectionModel.row.Mjesto)
                                  
    
                                    setPtt(newRowSelectionModel.row.PostBroj);
    
                                    
                                    setUlica(newRowSelectionModel.row.Ulica);
                               
    
    
                                    
                                    setTip(newRowSelectionModel.row.TipKorisnika);
                                    
    
                                    setDatumVal(newRowSelectionModel.row.Datum);
    
                                    

                                    setRucnoKBR('');
                                    setRucnoKBRDodatak('');
                                    setRucnoMjesto('');
                                    setRucnoUlica('');
                                    setRucnoNaziv1('');
                                    setRucnoNaziv2('');
                                    setSelectedRucnoTip(3);
                                  

                                       

                            }}


                            onRowClick={(rowChosen)=>{

                                console.log("Chosen row!!!!!");
                                console.log(rowChosen)

                            }}

                            
                            localeText={customLocaleText} 
                            
                    
                        
                    />}

    
                    </div>

                    {/* -------

                    {selectedCell && <div className="DPDonat-selected-row" onClick={()=> {
                        
                        setPojavljivanjeIsOpen(true)
                    }}>
                            {selectedCell.rbr} - {selectedCell.naziv}
                    </div>}

                   ---------------*/} 


                </div>

   
                {/*<div className="DPDonat-form">
                   


                     
                        {showBadData && <div className="DPDonat-form-first-part-left">
                            <Grid sx={{padding:'0', margin: '0 3px'}} container spacing={0.8} columns={{xs:12}}>
                             
                               
                                <Grid xs={3} >
                                    <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                   
                                     
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        
                                        fullWidth
                                        id=""
                                        label="Tel"
                                        variant="outlined"
                                        disabled
                                        value={telefon}
                                        onChange={(event) => {
                                            console.log("Written phone:");
                                            console.log(event.target.value);
                                            setTelefon(event.target.value);
                                        }}
                                    />

                                </Grid>
                                <Grid xs={3}  >
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label=""
                                        disabled
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                                <Grid xs={3} >
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="OIB"
                                        variant="outlined"
                                        disabled
                                        value={OIB}
                                        
                                        onChange={(event) => {
                                            setOIB(event.target.value);
                                        }}
                                    />
                                </Grid>
 
                                <Divider />




                             
                                <Grid xs={4} >
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Naziv"
                                        disabled
                                        variant="outlined"
                                        //value={naziv1}
                                        value = {name}
                                        
                                        onChange={(event) => {
                                            //setNaziv1(event.target.value);
                                            setName(event.target.value)
                                        }}
                                    />

                                </Grid>
                                <Grid xs={4} sm={4} md={4} lg={4} xl={4} >
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink:true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Naziv2"
                                        variant="outlined"
                                        //value={naziv12}
                                        value={surname}
                                        disabled
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>

                                <Grid xs={4} >
                                    
                                        <Button  sx={{height:"30px", fontSize:"10px"}}
                                                   
                                                    fullWidth
                                                    variant="contained"
                                                    onClick={() => {
                                                    
                                                        console.log("Mijenjam");
                                                        console.log(name);
                                                        console.log(surname);

                                                        let tmpName = name;
                                                        let tmpSurname = surname;

                                                        setName(tmpSurname);
                                                        setSurname(tmpName);

                                                        setFlagChangeName(true);
                                                    }}
                                            
                                                    >
                                                    Zamjena ime/prezime
                                        </Button>
                                </Grid>
                                <Divider />

                                
                               
                                <Grid xs={4}>



                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        disabled
                                        label="Mjesto"
                                        variant="outlined"
                                        value={mjesto}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>
                                <Grid xs={3} >
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="PTT"
                                        disabled
                                        variant="outlined"
                                        value={ptt}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                                <Grid xs={5} >
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Ulica"
                                        disabled
                                        variant="outlined"
                                        value={ulica}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                      
                                <Divider />

                    

                          
                                <Grid xs={3} >
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tip"
                                        disabled
                                        variant="outlined"
                                        value={tip}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                                
                                <Grid xs={3}>
                                   <TextField
                                        InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:'bold'}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Datum"
                                        disabled
                                        variant="outlined"
                                        value={datumVal}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                             
                                <Divider />


                            </Grid>
                        </div>}
                       
          
                        <div className="BadData-form-second-part-left">
                                <div style={{width:'69%', padding: '5px'}}> 
                                <div style={{padding: '0 0 7px 0'}}> <Typography>RUČNI ISPRAVCI NAZIVA, ADRESA I TIPOVA</Typography>  </div>             
                                    <Grid container spacing={1}>
                                        
                                        <Grid xs={12}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Naziv 1"
                                                disabled={!rucneKorekcije}
                                                variant="outlined"
                                                value={rucnoNaziv1}
                                                
                                                onChange={(event) => {
                                                        
                                                    setRucnoNaziv1(event.target.value);
                                                    
                                                }}
                                            />
                                        </Grid>

                                        
                                        <Grid xs={12}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Naziv 2"
                                                variant="outlined"
                                                value={rucnoNaziv2}
                                                disabled={!rucneKorekcije}
                                                
                                                onChange={(event) => {
                                                    setRucnoNaziv2(event.target.value);
                                                }}
                                            />
                                        </Grid>

                                        
                                        <Grid xs={12}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Mjesto"
                                                value={rucnoMjesto}
                                                disabled={!rucneKorekcije}
                                                variant="outlined"
                                                
                                                
                                                onChange={(event) => {

                                                    setRucnoMjesto(event.target.value);
                                                    searchForMjesto(event.target.value);
                                                    
                                                }}
                                        />
                                                {listMjesta.length!=0 && 
                                                <Box className="BijeleStranice-lista-ulice">
                                                
                                                    {listMjesta.map(ulica=> {
                                                            return (
                                                                <div className="BijeleStranice-lista-ulice-ulica" onClick={()=>{
                                                                    console.log(ulica)
                                                                    setSelectedMjesto(ulica)
                                                                    setRucnoMjesto(ulica.NAZIV);
                                                                    setTkcFirma(ulica.tkc)

                                                                    setListMjesta([])
                                                                }}>{ulica.NAZIV}</div>
                                                            )
                                                        })}
                                                </Box>}





                                        </Grid>


                                        
                                        <Grid xs={6}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Ulica"
                                                value={rucnoUlica}
                                                disabled={!rucneKorekcije}
                                                variant="outlined"
                                                
                                                                                
                                                onChange={(event) => {

                                                setRucnoUlica(event.target.value);

                                                searchForUlica(event.target.value);
                                                                                    
                                                }}
                                            />
                                            {listUlice.length!=0 && 
                                            <Box className="BijeleStranice-lista-ulice">
                                            
                                                {listUlice.map(ulica=> {
                                                        return (
                                                            <div className="BijeleStranice-lista-ulice-ulica" onClick={()=>{
                                                                console.log(ulica)
                                                                setSelectedUlica(ulica)
                                                                setRucnoUlica(ulica.NAZIV);
                                                                getMjestoFromUlica(ulica.MJESTO_ID);
                                                                
                                                                setListUlice([])
                                                            }}>{ulica.NAZIV}</div>
                                                        )
                                                    })}
                                            </Box>}

                                        </Grid>
                                        
                                        <Grid xs={3}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="KBr"
                                                value={rucnoKBR}
                                                disabled={!rucneKorekcije}
                                                variant="outlined"
                                                
                                                onChange={(event) => {
                                                    setRucnoKBR(event.target.value);
                                                    
                                                }}
                                            />
                                        </Grid>

                                        
                                        <Grid xs={3}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label=""
                                                value={rucnoKBRDodatak}
                                                disabled={!rucneKorekcije}
                                                variant="outlined"
                                                
                                                onChange={(event) => {
                                                    setRucnoKBRDodatak(event.target.value);
                                                    
                                                }}
                                            />
                                        </Grid>
                                        
                                        <Grid xs={12}>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around"}}>
                                                <Typography className="DPDonat-form-statistika-title" variant="p">
                                                        Tip
                                                </Typography>

                                                <FormControl>
                                                    <RadioGroup row
                                                    name="Tip"
                                                    //onChange={rucnoTipChange}
                                                    disabled={!rucneKorekcije}
                                                    >
                                                         <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Radio id='0' size="small" />} disabled={!rucneKorekcije} checked={selectedRucnoTip=='0'?true:false} label="Osobe" />  

                                                         <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Radio id='1' size="small" />} disabled={!rucneKorekcije} checked={selectedRucnoTip=='1'?true:false} label="Obrtnici" />
                                                         <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Radio id='2' size="small" />} disabled={!rucneKorekcije} checked={selectedRucnoTip=='2'?true:false} label="Firme" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </div>
                                        </Grid>

                                        
                                    </Grid>
                                

                                </div>

                               <div style={{width:'29%', padding: '4px'}}> 
                                    <Grid container spacing={1}>
                                     
                                        <Grid xs={12}>
                                            
                                            
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                    onClick={() => {
                                                            setRucnoNaziv1(name);
                                                            setRucnoNaziv2(surname);
                                                }}>
                                               Uzmi naziv
                                            </Button>
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                    onClick={() => {
                                                            setRucnoKBR('');
                                                            setRucnoKBRDodatak('');
                                                            setRucnoMjesto('');
                                                            setRucnoUlica('');
                                                            setRucnoNaziv1('');
                                                            setRucnoNaziv2('');
                                                            setSelectedRucnoTip(3);
                                                            //setRucneKorekcije(false);
                                                }}>
                                               Odustani
                                            </Button>
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                    onClick={() => {
                                                        rucnaKorekcija();
                                                }}>
                                               Prihvati pojedinačno
                                            </Button>
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                    onClick={() => {
                                            
                                                }}>
                                               Interval
                                            </Button>
                                        </Grid>
                                    </Grid>

                               </div>


                        </div>  
                </div>*/}
            </div>



        </div>
    </ThemeProvider >
  );
}

export default BadData;